import classNames from "classnames";
import React from "react";

export function Wrap({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={classNames("w-full h-full flex justify-center p-2", className)}
    >
      <div className="w-full max-w-[1728px]">{children}</div>
    </div>
  );
}
